// extracted by mini-css-extract-plugin
export var actionText = "_rs-4";
export var container = "_rs-0";
export var leftSection = "_rs-1";
export var rightSection = "_rs-2";
export var settingsButton = "_rs-6";
export var settingsIcon = "_rs-7";
export var shortcut = "_rs-5";
export var shortcutGroup = "_rs-3";